export default "__VITE_ASSET__sIB90srm__"